import { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import RouteFallback from "RouteFallback";

const TrainingSection: FC = () => {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Outlet />
    </Suspense>
  );
};
export default TrainingSection;
